import {groupCompanyApi} from '../api';
import {IDeleteDataGroupCompanyArgs, IPostDataGroupCompanyArgs, ITransfomedPutDataGroupCompanyArgs} from '../api/types';
import {IGetDataArgs} from '../model/types';

export const GroupCompanyTabTabService = {
    get: async (args?: IGetDataArgs) => {
        try {
            return await groupCompanyApi.getData(args);
        } catch (error) {
            throw new Error(error);
        }
    },

    getById: async (id: number) => {
        try {
            return await groupCompanyApi.getDataById(id);
        } catch (error) {
            throw new Error(error);
        }
    },

    post: async (args: IPostDataGroupCompanyArgs) => {
        try {
            const response = await groupCompanyApi.postData(args);

            return {response, isError: false};
        } catch (error) {
            console.error(error);

            return {response: error.response, isError: true};
        }
    },

    put: async (args: ITransfomedPutDataGroupCompanyArgs) => {
        try {
            return await groupCompanyApi.putData(args);
        } catch (error) {
            throw new Error(error);
        }
    },

    delete: async (rowsIds: IDeleteDataGroupCompanyArgs) => {
        try {
            return await groupCompanyApi.deleteData(rowsIds);
        } catch (error) {
            throw new Error(error);
        }
    },
};
